import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // Get GA Measurement ID from environment
    const measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID;

    // Skip if no measurement ID is configured
    if (!measurementId || measurementId === 'your-google-analytics-id-here') {
      return;
    }

    // Initialize gtag.js if not already done
    if (!window.dataLayer) {
      // Load gtag.js script dynamically
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head?.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag(...args) {
        window.dataLayer?.push(...args);
      };
      window.gtag('js', new Date());
      window.gtag('config', measurementId, {
        send_page_view: false // We'll manually send page views
      });
    }

    // Send page_view event on initial load and route changes
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
        page_location: window.location?.href,
        page_title: document.title
      });
    }
  }, [location]);
}

export default useGoogleAnalytics;